import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../shared/Footer.css';

const Footer = ({ currentBrand }) => {
  const location = useLocation();

  const isVelouraLanding = location.pathname === '/' && (!currentBrand || currentBrand === 'veloura');
  const isVagueLanding = location.pathname === '/' && currentBrand === 'vague';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToVague = () => {
    if (location.pathname === '/' && currentBrand === 'vague') {
      const vagueSection = document.getElementById('vague');
      if (vagueSection) {
        vagueSection.scrollIntoView({ behavior: 'smooth' });
      } else {
        scrollToTop();
      }
    }
  };

  const scrollToVeloura = () => {
    if (location.pathname === '/' && currentBrand === 'veloura') {
      scrollToTop();
    }
  };

  return (
    <footer className="footer" data-scroll-section>
      <div className="footer-container">
        <div className="footer-content">
          {}
          <div className="footer-logo-section">
            <Link to="/" className="footer-brand-logo" aria-label="Veloura home">
              <img
                src="https://i.ibb.co/Xx93pxTh/Veloura-Inc-Logo-8.png"
                alt="Veloura"
                className="footer-brand-logo-image"
              />
            </Link>
            <p className="footer-brand-tagline">Premium fashion &amp; lifestyle in Los Santos.</p>
          </div>
          {}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/shop">Shop</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
              <li>
                <Link to="/partners">Partners</Link>
              </li>
              <li>
                <Link to="/news">News</Link>
              </li>
              <li>
                {isVagueLanding ? (
                  <a href="#vague" onClick={(e) => { e.preventDefault(); scrollToVague(); }}>
                    Vague
                  </a>
                ) : (
                  <Link to="/" state={{ selectedBrand: 'vague' }}>Vague</Link>
                )}
              </li>

              <li>
                {isVelouraLanding ? (
                  <a href="#home" onClick={(e) => { e.preventDefault(); scrollToVeloura(); }}>
                    Veloura
                  </a>
                ) : (
                  <Link to="/" state={{ selectedBrand: 'veloura' }}>Veloura</Link>
                )}
              </li>
            </ul>
          </div>
          {}
          <div className="footer-section">
            <h4>Contact</h4>
            <ul className="footer-contact">
              <li>
                <span className="footer-label">Hotline:</span>
                <span className="footer-value">414</span>
              </li>
              <li>
                <span className="footer-value">
                  <a
                    href="https://gtaw.link/veloura"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link"
                  >
                    Veloura Portal
                  </a>
                </span>
              </li>
            </ul>
          </div>
          {}
          <div className="footer-section">
            <h4>Follow Us</h4>

            <ul className="footer-social">
              <li>
                <a
                  href="https://face.gta.world/page/veloura"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label="Facebrowser"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                  </svg>

                  <span>Facebrowser</span>

                </a>

              </li>

            </ul>

          </div>

        </div>


        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Veloura / Veloura Studios® / Vague®. All rights reserved.</p>

        </div>

      </div>

    </footer>

  );
};

export default Footer;
